<template>
  <Container type="card-full">
    <div slot="header">
      <el-button  @click="addFlexcol">新增</el-button>
      <el-button  @click="delFlexcol">删除</el-button>
      <el-button  @click="genFlexcol">生成</el-button>
      <el-button  @click="sortFlexcol">重新排序</el-button>
      <el-button  @click="close">关闭</el-button>
    </div>
    <div class="container">
      <vggrid ref="xGrid" class="vggrid" :list="list" tableheight="700" flexname=""
              :cols="cols"
              :showfooter="false"
              :showPage="false" :resizable="true"
              @cellClick="cellClick"></vggrid>

      <el-form :model="form" ref="form"  class="content ss-fl" v-if="flexcolform">
        <el-row>
          <el-col :span="5">
            <el-form-item label="序号" :label-width="formLabelWidth">
              <el-input v-model="form.flexcolseq" auto-complete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="列名" :label-width="formLabelWidth">
              <el-input v-model="form.flexcolcode" auto-complete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
        <el-form-item label="列说明" :label-width="formLabelWidth">
          <el-input v-model="form.flexcolname" auto-complete="off" ></el-input>
        </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form>
              <el-row>
                <el-col :span="5">
                  <el-form-item label="字段宽度" :label-width="formLabelWidth">
                    <el-select v-model="form.flexcoltype" :clearable="true" @change="changeType">
                      <el-option v-for="(item, index) in fieldtypeList" :label="item.label" :value="item.value" :key="index"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col  :span="5">
                  <el-form-item label="字段宽度" :label-width="formLabelWidth">
                    <el-input v-model="form.flexcolwid" auto-complete="off" >宽度</el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="字段小数位" :label-width="formLabelWidth">
                    <el-input v-model="form.flexcoldig" auto-complete="off" >小数位</el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="编辑列" :label-width="formLabelWidth">
              <el-select v-model="form.flexcoleditflg" :clearable="true" >
                <el-option v-for="(item, index) in flexcoleditflgList" :label="item.label" :value="item.value" :key="index"></el-option>
              </el-select>{{this.form.flexcolhide}}
              <el-checkbox v-model="form.flexcolgriggercol">触发列</el-checkbox>
              <el-checkbox v-model="form.flexcolissum">合计列</el-checkbox>
              <el-checkbox v-model="form.flexcolhide">隐藏列</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="计算列" :label-width="formLabelWidth">
              <el-input v-model="form.flexcolcalculexpr" auto-complete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="数据助手" :label-width="formLabelWidth">
              <el-select v-model="form.flexcolbrows" :clearable="true" >
                <el-option v-for="(item, index) in flexcolbrowsList" :label="item.label" :value="item.value" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="系统代码" :label-width="formLabelWidth">
              <el-input v-model="form.flexcolsyscode" auto-complete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="生成功能" :label-width="formLabelWidth">
              <el-select v-model="form.flexcoldocgenid" :clearable="true" >
                <el-option v-for="(item, index) in docgenList" :label="item.label" :value="item.value" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="返回字段" :label-width="formLabelWidth">
              <el-input v-model="form.flexcolgetvaluestr" auto-complete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="赋值字段" :label-width="formLabelWidth">
              <el-input v-model="form.flexcolsetvaluestr" auto-complete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="" :label-width="formLabelWidth">
          <el-button type="primary" @click="saveFlexcol">保存</el-button>
          <el-button type="danger" @click="delFlexcol">删除</el-button>
        </el-form-item>
      </el-form>
    </div>
  </Container>
</template>
<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vggrid from '../common/vggrid'
  export default {
    name: 'flexcolForm',
    data () {
      return {
        list: [],
        flexcolform: false,
        fieldtypeList:[],
        docgenList: [],
        flexcoleditflgList: [],
        flexcolbrowsList: [],
        flex: this.$route.params.form,
        cols: [
          { field: 'flexcolseq', title: '序号',calculExpr:'', addNewRowFlg: false},
          { field: 'flexcolcode', title: '字段名',calculExpr:'',addNewRowFlg: false},
          { field: 'flexcolname', title: '字段说明',calculExpr:'',addNewRowFlg: false},
        ],
        form: {},
        loading: true,
        formLabelWidth: '100px'
      }
    },
    created () {
    },
    activated() {
      this.init()
      this.getFlexcolList()
      this.getFieldtypeList()
      this.getFlexcoleditflgList()
      this.getFlexcolbrowsList()
      this.getFlexList()
      this.getDocgenList()
    },
    mounted () {
    },
    components: {vggrid},
    methods: {
      async init() {
        this.list = []
        this.flexcolform = false
        this.docgenList = []
        this.fieldtypeList = []
        this.flexcoleditflgList = []
        this.flexcolbrowsList = []
        this.flex = this.$route.params.form
        this.form = {}
      },
      async addFlexcol () {
        this.flexcolform = true
        let maxSeq = 0
        this.list.forEach(item => {
          if (item.flexcolseq>maxSeq) {
            maxSeq = item.flexcolseq
          }
        })
        maxSeq += 10
        this.form = {
          flexcolid: 0,
          flexcolseq: maxSeq,
          flexcolcode: '',
          flexcolname: '',
          flexcoltype: '',
          flexcolwid: '',
          flexcoldig: '',
          flexcolhide: '',
          flexcolbrows: '',
          flexcolgetvaluestr: '',
          flexcolsetvaluestr: '',
          flexcolgriggercol: '',
          flexcolcalculexpr: '',
          flexcolissum: '',
          flexcoleditflg: '',
          flexcolsyscode: '',
          flexcoldocgenid: ''
        }
      },
      async getFieldtypeList() {
        this.fieldtypeList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'fieldtype'}
        })
      },
      async getFlexcoleditflgList() {
        this.flexcoleditflgList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'flexcoleditflg'}
        })
      },
      async getFlexcolbrowsList() {
        this.flexcolbrowsList = await request({
          url: '/kfgl/brows/getBrowsList',
          method: "get",
          params: {comid: 1}
        })
      },
      async getFlexList() {
        this.flexList = await request({
          url: '/kfgl/flex/getFlexList',
          method: "get",
          params: {comid: 1}
        })
      },
      async getDocgenList() {
        this.docgenList = await request({
          url: '/kfgl/docgen/getDocgenList',
          method: "get",
          params: {flexid: this.flex.flexid}
        })
      },
      async changeType() {
        switch (this.form.flexcoltype) {
          case 'C':
            console.log(this.form.flexcoltype)
            this.form.flexcolwid = 20
            this.form.flexcoldig =0
          case 'L':
            this.form.flexcolwid = 10
            this.form.flexcoldig =0
          case 'N':
            this.form.flexcolwid = 5
            this.form.flexcoldig =0
          case 'B':
            this.form.flexcolwid = 3
            this.form.flexcoldig =0
          case 'F':
            this.form.flexcolwid = 12
            this.form.flexcoldig =2
          case 'D':
            this.form.flexcolwid = 0
            this.form.flexcoldig =0
          case 'T':
            this.form.flexcolwid = 0
            this.form.flexcoldig =0
        }
      },
      async genFlexcol() {
        console.log(this.flex)
        let data = await request({
          url: '/kfgl/flex/genFlexcolByBrows',
          method: "post",
          data: {flexid: this.flex.flexid,browsid: this.flex.browsid,comid: this.$store.getters.loginUser.usercomid}
        })
        if (data.issuccess === 1) {
          this.getFlexcolList()
          this.$message.success('生成成功！')
        } else {
          this.$message.error('生成失败！')
        }
      },
      async sortFlexcol () {
        let data = await request({
          url: '/kfgl/flex/sortFlexcol',
          method: "post",
          data: this.list
        })
        if (data.issuccess === 1) {
          this.getFlexcolList()
          this.$message.success('排序成功！')
        } else {
          this.$message.error('排序失败！')
        }
      },
      async delFlexcol () {
        console.log(this.fc)
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/kfgl/flex/delFlexcol',
            method: "post",
            data: this.form
          })
          if (data.issuccess === 1) {
            this.getFlexcolList()
            this.$message.success('删除成功！')
          }
        })
      },
      async saveFlexcol () {
        this.form.flexcolcomid = this.$store.getters.loginUser.usercomid
        this.form.flexcolflexid = this.flex.flexid
//        console.log(this.form)
//        if (this.form.flexcolhide === '1') {
//          this.form.flexcolhide = true
//        } else {
//          this.form.flexcolhide = false
//        }
//        if (this.form.flexcolgriggercol === 1) {
//          this.form.flexcolgriggercol = true
//        } else {
//          this.form.flexcolgriggercol = false
//        }
//        if (this.form.flexcolissum === '1') {
//          this.form.flexcolissum = true
//        } else {
//          this.form.flexcolissum = false
//        }
        console.log(this.form)
        await request({
          url: '/kfgl/flex/saveFlexcol',
          method: "post",
          data: this.form
        })
        this.$message.success('操作成功')
        await this.getFlexcolList()
        this.flexcolform = false
      },
      async cellClick (row) {
        this.form = row.row
        if (this.form.flexcolhide === '1') {
          this.form.flexcolhide = true
        } else {
          this.form.flexcolhide = false
        }
        if (this.form.flexcolgriggercol === 1) {
          this.form.flexcolgriggercol = true
        } else {
          this.form.flexcolgriggercol = false
        }
        if (this.form.flexcolissum === '1') {
          this.form.flexcolissum = true
        } else {
          this.form.flexcolissum = false
        }
        this.flexcolform = true
      },
      async pagechange (fcPage) {
        this.query.currPage = fcPage.currentPage
        this.query.pageSize = fcPage.pageSize
        this.getFlexcolList()
      },
      async getFlexcolList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/kfgl/flex/getFlexcolListByFlexid',
          params: {flexid: this.flex.flexid,comid: this.$store.getters.loginUser.usercomid}
        })
        this.list = res
        this.loading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'flexIndex'})
      }
    },
    filters: {
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    .vggrid {
      border: 1px solid #d1dbe5;
      width: 400px;
      margin-right: 5px;
    }
    .content {
      width: 100%;
      padding-top: 10px;
      padding-right: 10px;
      border: 1px solid #d1dbe5;
    }
  }
  #menuReportDiv {
    height: 380px;
    overflow: auto;
  }
</style>
